<template>
	<div v-loading="loading">
		<section class="left-top-cls">
			<div class="basis-cls">
				<el-select v-model="listQuery.showTypeTem" @change="changeShowTypeTem" :disabled="isFilter || !StoreTelRoles.includes('code://auth-tl')" placeholder="请选择" size="mini" style="width: 90px;vertical-align: top;">
					<el-option v-for="item in ['今天', '昨天', '近三天', '近七天']" :key="item" :label="item" :value="item"></el-option>
				</el-select>
				<el-input v-model="listQuery.phoneNumber" @keyup.enter.native="getList" placeholder="搜索手机号" size="mini" :style="'width: ' + (StoreTelRoles.includes('code://auth-tl') ? 165 : 180) + 'px;margin: 0 5px;vertical-align: top;'" clearable>
					<i @click.stop="getList" slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;"></i>
				</el-input>

				<div class="filter-cls" v-if="StoreTelRoles.includes('code://auth-tl')">
					<!-- <svg-icon @click.stop="isFilter = !isFilter" icon-class="filter" style="vertical-align: top;height: 28px;font-size: 14px;color: #606266;" /> -->
					<div class="filter-context-cls" v-show="isFilter">
						<div class="top">
							<span>呼叫时间</span>
							<el-date-picker
								v-model="listQuery.date"
								:picker-options="pickerOptions"
								:clearable="false"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" size="mini" style="width: 225px">
							</el-date-picker>
						</div>
						<div class="bottom">
							<span>接通类型</span>
							<el-radio-group v-model="listQuery.ibStatus">
								<el-radio label="" style="margin-right: 5px">全部</el-radio>
								<el-radio :label="1" style="margin-right: 5px">已接</el-radio>
								<el-radio :label="2" style="margin-right: 5px">未接</el-radio>
							</el-radio-group>
							<el-button @click.stop="getList()" type="primary" size="mini">搜索</el-button>
						</div>
					</div>
				</div>
			</div>

			<div class="filter-text-cls" v-show="listQuery.date">
				<span>{{listQuery.ibStatus == 1 ? '已接' : listQuery.ibStatus == 2 ? '未接' : '全部'}}</span>
				<span>{{listQuery.date[0] | formatDate('YYYY-MM-DD')}} - {{listQuery.date[1] | formatDate('YYYY-MM-DD')}}</span>
				<i @click.stop="handleCloseFilter" class="el-icon-delete-solid"></i>
			</div>

			<div class="title-cls">
				<span>来电号码</span>
				<span>通话时长</span>
			</div>
		</section>

		<section class="left-bottom-cls" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
			<div class="cell" @click.stop="handleView(item)" v-for="(item, index) in list" :key="index" :class="{'active': item.histId === active, 'missed': item.ibStatus === '2', 'picked-up': item.ibStatus === '0', 'busy-xian': item.ibStatus === '1'}">
				<div class="top">
					<span>{{isShowPhone ? (item.phoneNumber.length === 12 ?(item.phoneNumber.substring(1,12)) : item.phoneNumber) : (hiddenPhone(item.phoneNumber.length === 12 ?(item.phoneNumber.substring(1,12)) : item.phoneNumber))}}</span>
					<!-- <span>{{(item.phoneNumber.length === 12 ? item.phoneNumber.substring(1,12) : item.phoneNumber) | phoneSpace}}</span> -->
					<span v-show="['1', '2'].includes(item.ibStatus)">{{item.ibStatus === '1' ? '已接' : item.ibStatus === '2' ? '未接' : ''}}</span>
					<span v-show="item.callDuration">{{item.callDuration}}</span>
					<span v-show="($$(StoreIsCallCurrentInfo, 'histId') === item.histId) && StoreIsAnswer">{{StoreCallTime}}</span>
				</div>
				<div class="bottom">{{item.callTime}}</div>
			</div>
			<div class="station" v-if="loading">加载中...</div>
			<div class="station" v-if="noMore && list.length !== 0">没有更多了</div>
			<el-empty v-if="list.length === 0" description="暂无数据"></el-empty>
		</section>
	</div>
</template>

<script>
import { pickerOptionsMixin } from "@/utils/mixins";
import { mapGetters } from 'vuex';
export default {
	name: "TelChannelPageLeftItem",
	props: ['activeName'],
	mixins: [pickerOptionsMixin],
	computed: {
		pickerOptions() {
            return {
                disabledDate: function(date) {
                    let before = new Date();
                    before.setDate(before.getDate() - 7);
                    let now = new Date();
                    return date < before || date > now;
                }
            };
        },
		noMore() {
			return this.listQuery.pageNumber >= this.totalSize ;
		},
		disabled() {
			return this.loading || this.noMore;
		},
		...mapGetters([
			'userInfo',
			'StoreIsCall',
			'StoreIsCallCurrentInfo',
			'StoreCallTime',
			'StoreIsAnswer',
			'StoreTelRoles',
			'StoreIsIdle',
			'isShowPhone'
		])
	},
	data() {
		return {
			active: '',
			isFilter: false,
			listQuery: {
				pageNumber: 1,
				pageSize: 20,
				phoneNumber: '',
				showType: 1,
				ibStatus: '',
				startDate: '',
				endDate: '',
				showTypeTem: '今天',
				date: '',
			},
			totalSize: 0,
			list: [],
			loading: false
		}
	},
	watch: {
		StoreIsCall: {
			handler: function(val) {
				// if(val) {
					if(this.StoreIsIdle) {
						setTimeout(() => {
							this.getList(null, 'IB');
						}, 500);
					}
				// }
			},
			immediate: true,
			deep: true
		},
		StoreIsAnswer: {
			handler: function(val) {
				// if(val) {
					if(this.StoreIsIdle) {
						setTimeout(() => {
							this.getList();
						}, 500);
					}
				// }
			},
			immediate: true,
			deep: true
		},
		isFilter: {
			handler: function(val) {
				if(val) {
					const year = new Date().getFullYear();
					const month = new Date().getMonth();
					const date = new Date().getDate();
					switch(this.listQuery.showTypeTem) {
						case '今天': {
							this.listQuery.date = [new Date(), new Date()];
							break;
						}
						case '昨天': {
							this.listQuery.date = [new Date(year, month, date - 1), new Date(year, month, date - 1)];
							break;
						}
						case '近三天': {
							this.listQuery.date = [new Date(year, month, date - 2), new Date()];
							break;
						}
						case '近七天': {
							this.listQuery.date = [new Date(year, month, date - 6), new Date()];
							break;
						}
						case '我的通话': {
							this.listQuery.showType = 1;
							this.listQuery.date = [new Date(), new Date()];
							break;
						}
					}
				}
			},
			immediate: true,
			deep: true
		},
		'listQuery.showTypeTem': {
			handler: function(val) {
				switch(val) {
					case '今天':
					case '昨天':
					case '近三天':
					case '近七天': {
						this.listQuery.showType = this.StoreTelRoles.includes('code://auth-tl') ? 2 : 1;
						break;
					}
					case '我的通话': {
						this.listQuery.showType = 1;
						break;
					}
				}
			},
			immediate: true,
			deep: true
		},
		activeName: {
			handler: function(val) {
				this.active = val;
			},
			immediate: true,
			deep: true
		},
	},
	mounted() {
		document.getElementById('rightContainer').onclick = () => {
			this.isFilter = false;
		};
	},
	created() {
		this.listQuery.showType = this.StoreTelRoles.includes('code://auth-tl') ? 2 : 1;
		this.getList(null, 'IB');
	},
	methods: {
		getList(type, category) {
			this.isFilter = false;
			this.loading  = true;
			if(type !== 'load') {
				this.listQuery.pageNumber = 1;
			}
			this.$api.apiPostCallIbContactList(this.listQuery).then(response => {
				if(response.errcode != 0 || !response.data) {
					this.loading = false;
					return;
				}
				this.list = type === 'load' ? this.list.concat(response.data) : response.data;				
				this.totalSize = response.pages;
				if(this.list.length > 0 && category === 'IB') {
					this.handleView(this.list[0]);
				}
				this.loading = false;
			});
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		handleView(row) {
			this.active = row.histId;
			this.$emit('handleActiveNameLeft', row, row.histId);
		},
		handleCloseFilter() {
			this.listQuery.ibStatus = '';
			this.listQuery.date = '';
			this.getList();
		},
		changeShowTypeTem(e) {
			this.listQuery.showType = e === '我的通话' ? 1 : 2;
			this.listQuery.ibStatus = '';
			this.listQuery.date = '';
			this.getList();
		},
		load() {
			this.loading = true;
			this.listQuery.pageNumber += 1;
			this.getList('load');
		}
	}
}
</script>

<style lang="scss" scoped>
.left-top-cls {
	width: 320px;
	padding: 0 18px 6px 22px;
	box-sizing: border-box;
	
	& > .basis-cls {
		width: 100%;
		height: 28px;
		margin-bottom: 12px;

		& > .filter-cls {
			width: 12px;
			height: 28px;
			vertical-align: top;
			float: right;
			cursor: pointer;
			position: relative;

			& > .filter-context-cls {
				width: 300px;
				background: #fff;
				position: absolute;
				top: 35px;
				right: -10px;
				border-radius: 4px;
				z-index: 2;
				box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
				padding: 10px;
				box-sizing: border-box;

				&:before {
					content: '';
					width: 0;
					height: 0;
					border: 5px solid transparent;
					border-bottom-color: rgba(0, 0, 0, 0.1);
					position: absolute;
					top: -10px;
					right: 10px;
				}

				&:after {
					content: "";
					width: 0;
					height: 0;
					border: 5px solid transparent;
					border-bottom-color: #fff;
					position: absolute;
					top: -9px;
					right: 10px;
				}

				& > .top {
					margin-bottom: 10px;
					& > span {
						display: inline-block;
						width: 55px;
						font-size: 12px;
						color: #3c4353;
					}
				}


				& > .bottom {
					& > span {
						display: inline-block;
						width: 55px;
						font-size: 12px;
						color: #3c4353;
						line-height: 30px;
					}

					::v-deep .el-radio__label {
						padding: 4.2px;
					}

					& .el-button {
						vertical-align: top;
					}
				}
			}
		}
	}

	& > .filter-text-cls {
		width: 100%;
		position: relative;
		font-size: 12px;
		
		

		& > span {
			display: inline-block;
			border: solid 1px #337EFF;
			padding: 2px 5px;
			border-radius: 2px;
			box-sizing: border-box;
			margin-right: 8px;
			background: rgba(51, 126, 255, 0.1);
			vertical-align: top;
			line-height: 16px;
			margin: 5px 8px 5px 0;
			color: #337EFF;
		}

		& > i {
			width: 30px;
			height: 30px;
			vertical-align: top;
			float: right;
			font-size: 16px;
			text-align: center;
			line-height: 35px;
			cursor: pointer;
			color: #C3C9D0;

		}
	}

	& > .title-cls {
		width: 100%;
		height: 42px;
		padding-bottom: 6px;
		box-sizing: border-box;
		position: relative;
		border-bottom: solid 1px #D8D8D8;

		& > span {
			font-size: 14px;
			
			font-weight: 500;
			color: #337EFF;
			line-height: 42px;

			&:nth-of-type(2) {
				float: right;
				color: #566980;
			}
		}
	}

	
}
.left-bottom-cls {
	width: 320px;
	height: calc(100vh - 124px - 94px - 16px);
	overflow-x: hidden;
	overflow-y: auto;

	& > .cell {
		width: 100%;
		height: 70px;
		padding: 14px 18px 14px 22px;
		box-sizing: border-box;
		cursor: pointer;
		position: relative;
		overflow: hidden;

		&::before {
			content: "";
			width: calc(100% - 22px - 18px);
			height: 1px;
			background: #D8D8D8;
			position: absolute;
			bottom: 0;
			left: 22px;
		}

		& > .top {
			width: 100%;
			height: 22px;
			margin-bottom: 4px;
			font-size: 16px;
			
			font-weight: 400;
			color: #3C4353;
			line-height: 22px;

			& > span:nth-of-type(2) {
				display: inline-block;
				width: 40px;
				height: 18px;
				border-radius: 3px;
				font-size: 12px;
				
				font-weight: 400;
				color: #566980;
				line-height: 18px;
				text-align: center;
				vertical-align: top;
				margin-top: 2px;
				margin-left: 10px;
				background-color: #F2F8FF;
			}

			& > span:nth-of-type(3) {
				float: right;
				position: relative;

				&::before {
					content: "";
					width: 6px;
					height: 6px;
					background: #3C4353;
					border-radius: 3px;
					position: absolute;
					top: 8px;
					left: -10px;
				}
			}

			& > span:nth-of-type(4) {
				float: right;
				position: relative;
				font-size: 16px;
				
				font-weight: 400;
				color: #566980;
				line-height: 18px;
				text-align: center;
			}
		}

		&.active {
			background: #EDF5FF;
		}

		&:hover {
			background: #f7f8fa;
		}

		& > .bottom {
			width: 100%;
			font-size: 12px;
			
			font-weight: 400;
			color: #6C7E91;
			line-height: 17px;
		}

		&.missed {
			& > .top > span:nth-of-type(1), & > .top > span:nth-of-type(2) {
				color: #FF504D;
			}

			& > .top > span:nth-of-type(2) {
				background: #FFECEC;
			}

			& > .top > span:nth-of-type(3)::before {
				background: #FF504D;
			}
		}

		&.picked-up {
			& > .top > span:nth-of-type(1), & > .top > span:nth-of-type(2) {
				color: #3C4353;
			}

			& > .top > span:nth-of-type(2) {
				background: #F2F8FF;
			}

			& > .top > span:nth-of-type(3)::before {
				background: #3C4353;
			}
		}

		&.busy-xian {
			& > .top > span:nth-of-type(1), & > .top > span:nth-of-type(2) {
				color: #47B267;
			}

			& > .top > span:nth-of-type(2) {
				background: #F1FFF5;
			}

			& > .top > span:nth-of-type(3)::before {
				background: #47B267;
			}
		}
	}

	& > .station {
		font-size: 14px;
		color: #909399;
		line-height: 70px;
		text-align: center;
	}
}
</style>